import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { DeleteRegular } from "@fluentui/react-icons";
import { useController, useFormContext } from "react-hook-form";

interface EvaluationInputProps {
  categoryIndex: number;
  subCategoryIndex: number;
  questionIndex: number;
  index: number;
  onRemove: () => void;
}

function EvaluationInput({
  categoryIndex,
  subCategoryIndex,
  questionIndex,
  index,
  onRemove,
}: EvaluationInputProps) {
  const { control } = useFormContext<FormValues>();

  const { field: contentField } = useController({
    control,
    name: `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions.${questionIndex}.evaluations.${index}.content`,
  });

  const { field: weightField } = useController({
    control,
    name: `categories.${categoryIndex}.subcategories.${subCategoryIndex}.questions.${questionIndex}.evaluations.${index}.weight`,
  });

  return (
    <div className="flex gap-2">
      <div className="grow">
        <Input {...contentField} />
      </div>
      <div className="w-[96px]">
        <Input placeholder="0.0 ~ 1.0" type="number" {...weightField} />
      </div>
      <div>
        <Button size="icon" variant="ghost" onClick={onRemove}>
          <DeleteRegular fontSize={24} />
        </Button>
      </div>
    </div>
  );
}

export default EvaluationInput;
